const _hashUserEmail = user => {
  if (user && user.email) {
    return `_${user.email.hashMe()}`;
  }
  return "_default";
};

export const getDataObject = path =>
  path.split(".").reduce((acc, object) => {
    if (!acc[object]) {
      acc[object] = {};
    }
    return acc[object];
  }, Fraction.Data);

export const savePersist = user => {
  const persisted = getDataObject("User.Persist");
  setItem(`${_hashUserEmail(user)}_fraction_data`, JSON.stringify(persisted));
};

export const setItem = (key, val) => {
  try {
    return localStorage.setItem(key, val);
  } catch (e) {}
};
